(function() {
    AOS.init({
        once: true
    });
})();